import { Injectable } from "@angular/core";

@Injectable()
export class PagerService {

  private calculatePager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
    const totalPages = Math.ceil(totalItems / pageSize);

    currentPage = Math.max(1, Math.min(currentPage, totalPages));

    let startPage: number, endPage: number;

    if (totalPages <= 10) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
    const pages = Array.from({ length: (endPage - startPage + 1) }, (_, i) => startPage + i);

    return {
      totalItems,
      currentPage,
      pageSize,
      totalPages,
      startPage,
      endPage,
      startIndex,
      endIndex,
      pages
    };
  }

  // Main method (original)
  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
    return this.calculatePager(totalItems, currentPage, pageSize);
  }

  getPagerR(totalItems: number, currentPage: number = 1, pageSize: number) {
    return this.calculatePager(totalItems, currentPage, pageSize);
  }

  getPagerQuantitydisquant(totalItems: number, currentPage: number = 1, pageSize: number) {
    return this.calculatePager(totalItems, currentPage, pageSize);
  }

  getPagerIndirectpromocost(totalItems: number, currentPage: number = 1, pageSize: number) {
    return this.calculatePager(totalItems, currentPage, pageSize);
  }

  getPagerSupportpromocost(totalItems: number, currentPage: number = 1, pageSize: number) {
    return this.calculatePager(totalItems, currentPage, pageSize);
  }
}
